import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useState } from "react";
import axios from "axios";
import baseUrl from "../../../../BaseURL";
import AlertPOP from "../../../../routes/AlertPOP";
import { ContextData } from "../../../../context/Context";
import validator from "validator";
import { Tooltip } from "@mui/material";
import Loader from "../../../../routes/Loader";
import AddIcon from "@mui/icons-material/Add";


export default function SetPaymentRegisterForm() {

  const [open, setOpen] = React.useState(false);
  const { RefreshUesFF, setRefreshUesFF, GlobalLoader, setGlobalLoader } = React.useContext(ContextData);
  const [OpenLoader, setOpenLoader] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // Form start---------->

  const [formData, setFormData] = useState({
    scholarship_name: "",
    scholarship_type: "",
    qualification_type: "",
    residential_type: "",
    will_pay: "",
    amount_to_pay: "0.00",
    scholarship_description: ""
  });

  const handleInputChange = (field) => (e) => {
    setFormData({ ...formData, [field]: e.target.value });
  };

  const [message, setMessage] = useState("");
  const [openAlert, setOpenAlert] = useState(false);
  const [transition, setTransition] = useState(undefined);

  // Handle the alert transition and function
  const handleClick = () => {
    setTransition(() => "TransitionLeft");
    setOpenAlert(true);
  };

  // Handle the close alert box
  const handleCloseAlert = () => {
    setOpenAlert(false);
  };

  // Handle submit
  const handleSubmit = (e) => {
    e.preventDefault();

    // Call Alert Box function
    handleClick("left");

    // Check for empty fields excluding will_pay
    const isEmptyField = Object.entries(formData).some(([key, value]) => key !== "amount_to_pay" && value === "");

    if (isEmptyField) {
      setMessage("Please fill out all fields");
      return;
    }

    if (formData.will_pay === "yes") {
      if (!validator.isNumeric(formData.amount_to_pay)) {
        setMessage("Amount is not a number");
        return;
      }
      if (formData.amount_to_pay === "") {
        setMessage("Amount to pay must not be empty");
        return;
      }
    } else if (formData.will_pay === "no" && formData.amount_to_pay !== "0.00") {
      setMessage("Amount to pay must be 0.00 when will pay is No");
      return;
    }
    setOpenLoader(true);
    // Submit the form (you can implement your submission logic here)
    axios
      .post(`${baseUrl}/auth/add_scholarship`, formData, {
        withCredentials: true,
        headers: {
          Accept: "application/json"
        }
      })
      .then((res) => {
        if (res.data.status) {
          setMessage(res.data.statusText);
          setRefreshUesFF(!RefreshUesFF);
          setOpenLoader(false);
          setFormData({
            scholarship_name: "",
            scholarship_type: "",
            qualification_type: "",
            residential_type: "",
            will_pay: "",
            amount_to_pay: "0.00",
            scholarship_description: ""
          });
          setGlobalLoader(!GlobalLoader);
        }
      })
      .catch((err) => {
        setOpenLoader(false);
        if (err) return console.log(err);
      });
  };

  // Form end --------->

  return (
    <React.Fragment>
      <Loader OpenLoader={OpenLoader} />
      <Button variant="contained" onClick={handleClickOpen} startIcon={<AddIcon />}>
        Add Scholarship
      </Button>
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="py-10"
      >
        <AlertPOP
          Open={openAlert}
          handleClose={handleCloseAlert}
          transition={transition}
          message={message}
        />
        <DialogTitle id="alert-dialog-title">New Scholarship</DialogTitle>
        <DialogContent>
          <form onSubmit={handleSubmit}>
            <TextField
              label="Scholarship Name"
              variant="outlined"
              fullWidth
              margin="normal"
              value={formData.scholarship_name}
              onChange={handleInputChange("scholarship_name")}
            />
            <TextField
              select
              label="Scholarship Type"
              variant="outlined"
              fullWidth
              margin="normal"
              value={formData.scholarship_type}
              onChange={handleInputChange("scholarship_type")}
            >
              <MenuItem value="local">Local</MenuItem>
              <MenuItem value="foreign">Foreign</MenuItem>
            </TextField>
            <TextField
              select
              label="Qualification Type"
              variant="outlined"
              fullWidth
              margin="normal"
              value={formData.qualification_type}
              onChange={handleInputChange("qualification_type")}
            >
              <MenuItem value="undergraduate">Undergraduate</MenuItem>
              <MenuItem value="postgraduate">Postgraduate</MenuItem>
              <MenuItem value="both">Both</MenuItem>
            </TextField>
            <TextField
              select
              label="Residential Type"
              variant="outlined"
              fullWidth
              margin="normal"
              value={formData.residential_type}
              onChange={handleInputChange("residential_type")}
            >
              <MenuItem value="indigene">Indigene</MenuItem>
              <MenuItem value="resident">Resident</MenuItem>
              <MenuItem value="both">Both</MenuItem>
            </TextField>
      
            <label>Will Pay :</label>
            <RadioGroup
              row
              value={formData.will_pay}
              onChange={handleInputChange("will_pay")}
            >
              <FormControlLabel value="yes" control={<Radio />} label="Yes" />
              <FormControlLabel value="no" control={<Radio />} label="No" />
            </RadioGroup>
            <Tooltip title="Will Pay means is there a payment for this scholarship before applying. If yes, then put the amount. If no, then leave it the way it is.">
              {formData.will_pay === "yes" && (
                <TextField
                  label="Amount to Pay"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  value={formData.amount_to_pay}
                  onChange={handleInputChange("amount_to_pay")}
                />
              )}
            </Tooltip>
            <TextField
              label="Scholarship Description"
              variant="outlined"
              fullWidth
              margin="normal"
              multiline
              rows={4}
              value={formData.scholarship_description}
              onChange={handleInputChange("scholarship_description")}
              inputProps={{ maxLength: 7000 }}
            />

            <Button type="submit" variant="contained" color="primary">
              Add
            </Button>
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
